module.exports = __webpack_public_path__ + "media/wan.07b3b291.wav";